import { ref, onMounted, watch } from "vue";
import i18next from "i18next";
import $ls, { LocalStorageKey } from "@/utils/local-storage";

export enum Language {
  FR = "fr",
  EN = "en",
}

export const useLanguage = () => {
  const language = ref<Language>(Language.FR);

  const applyLanguage = (lng: Language) => {
    i18next.changeLanguage(lng);
    document.documentElement.setAttribute("lang", lng);
  };

  const setLanguage = (lng: Language) => {
    language.value = lng;
    applyLanguage(lng);
    $ls.setItem(LocalStorageKey.LANGUAGE, lng);
  };

  onMounted(() => {
    const saved = $ls.getItem(LocalStorageKey.LANGUAGE) as Language | null;
    if (saved) {
      setLanguage(saved);
    } else {
      const browserLang = navigator.language.startsWith("fr")
        ? Language.FR
        : Language.EN;
      setLanguage(browserLang);
    }
  });

  watch(language, (newVal) => {
    $ls.setItem(LocalStorageKey.LANGUAGE, newVal);
  });

  return {
    language,
    setLanguage,
  };
};
